<template>
  <div class="box shadow trasparent">
    <figure class="avatar">
      <img src="../../static/tzb-icon.png" alt="Logo cnos-fap" style="width:80px;" />
    </figure>

    <div>
      <article v-if="message === 'per adesso lascia stare'" class="message is-danger">
        <div class="message-body" style="margin-top:3px;padding:0px">
          {{message}}
          <span class="is-pulled-right" style="padding:4px">
            <button class="delete is-small" aria-label="delete" @click="message = null" />
          </span>
        </div>
      </article>
      <section v-if="message != null">
        <section v-if="requestSent">
          <article class="message is-danger">
            <div class="message-body" style="margin-top:3px;padding:0px;">
              La richiesta è stata registrata.
              <br />Presto tale richiesta verrà analizzata dal personale autorizzato.
            </div>
          </article>
        </section>
        <section v-if="requestSent === false">
          <article class="message is-danger">
            <div class="message-body" style="margin-top:3px;padding:0px;">
              Nessun utente trovato con questa email.
              <br />Se intendi utilizzare questa email per il login, compila i dati e attendi l'autorizzazione
            </div>
          </article>
          <div class="field">
            <label class="label is-pulled-left">Nome</label>
            <div class="control">
              <input
                v-model="userRequest.firstName"
                class="input"
                type="text"
                :class="{'is-danger': userRequest.firstName.length<3}"
                placeholder="Esempio: Giovanni"
              />
            </div>
            <p
              v-if="userRequest.firstName.length < 3 && validateInputs"
              class="help is-danger"
            >Inserire almeno 3 lettere</p>
          </div>
          <div class="field">
            <label class="label is-pulled-left">Cognome</label>
            <div class="control">
              <input
                v-model="userRequest.lastName"
                class="input"
                type="text"
                :class="{'is-danger': userRequest.lastName.length<3}"
                placeholder="Esempio: Bosco"
              />
            </div>
            <p
              v-if="userRequest.lastName.length < 3 && validateInputs"
              class="help is-danger"
            >Inserire almeno 3 lettere</p>
          </div>
          <div class="field">
            <label class="label is-pulled-left">Codice Fiscale</label>
            <div class="control">
              <input
                v-model="userRequest.codiceFiscale"
                class="input"
                :class="{'is-danger': userRequest.codiceFiscale.length!=16, 'is-success': userRequest.codiceFiscale.lengt==16}"
                type="text"
                placeholder="Esempio GVNBSC15M19C722K"
              />
            </div>
            <p
              v-if="!checkCF(userRequest.codiceFiscale) && validateInputs"
              class="help is-danger"
            >Controllare la validità</p>
          </div>
          <div class="field">
            <label class="label is-pulled-left" style="margin-right: 50px">Centro</label>
            <div class="control">
              <div class="select">
                <select v-model="userRequest.school">
                  <option v-for="school in schools" :value="school" :key="school.id">{{school.slug}}</option>
                </select>
              </div>
            </div>
            <p
              v-if="userRequest.school.id === '' && validateInputs"
              class="help is-danger"
            >Selezionare un valore</p>
          </div>
          <a class="button is-primary is-medium is-block" @click="sendRequest()">
            <span>Invia</span>
          </a>
        </section>
      </section>
      <section v-if="message == null">
        <a class="button is-primary is-medium is-block" @click="gplusLogin()">
          <span class="icon">
            <i class="fa fa-user"></i>
          </span>
          <span>Google @cnosfap.net</span>
        </a>
        <a class="button is-danger is-medium is-block" disabled>
          <span>Google login</span>
        </a>
        <a class="button is-info is-medium is-block" disabled>
          <span>Facebook login</span>
        </a>
        <p class="has-text-black" style="margin-top:20px;">
          <a href="http://extranet.cnosfap.net/accesso.php">
            <strong>Accesso collaboratori</strong>
          </a>
        </p>
      </section>
    </div>

    <!-- <b-notification type="is-warning" :active="message != null">{{message}}</b-notification> -->
  </div>
</template>

<script>
import Vue from 'vue'
import cf from 'codice-fiscale-js'
import { COOKIE_DOMAIN } from '@/service/config'
import { parse } from '@/service/query'
// import {
//   getSchools,
//   getWaitingList,
//   setWaitingList,
//   searchContactByCF,
//   getYearId,
// } from '@/service/tzb'

export default {
  data() {
    return {
      message: this.$route.query.message,
      userRequest: {
        email: '',
        firstName: '',
        lastName: '',
        codiceFiscale: '',
        schoolId: '',
        school: {
          id: '',
          slug: '',
        },
        status: 'waiting',
        contactId: '',
        date: new Date(),
      },
      schools: [],
      requestSent: null,
      validateInputs: false,
    }
  },

  async created() {
    this.userRequest.email = Vue.cookie.get('contactEmail')
    if (this.message != null) {
      // const year = await getYearId()
      const year = await this.$api.getCustom('TzbTools', 'getYearId', {})
      // this.schools =await getSchools(year.yearId)
      const yearSchools = await this.$api.getById('TzbYears', year)
      this.schools = yearSchools.schools
      // const requested = await getWaitingList(this.userRequest.email)
      const filter = {
        where: {
          email: this.userRequest.email,
          status: 'waiting',
        },
      }
      const requested = await this.$api.get('TzbWaitingUsersLists', filter)
      this.requestSent = requested.length > 0
    }
  },

  methods: {
    cf,
    gplusLogin() {
      let { redirectTo } = parse(window.location.search)
      if (redirectTo) {
        redirectTo = window.location.href
      } else {
        redirectTo = `${window.location.href}landing`
      }

      this.$cookie.set('redirectTo', redirectTo, {
        path: '/',
        domain: COOKIE_DOMAIN,
      })
      // Prendo l'API_URL e tolgo le ultime 3 lettere
      // ASSOLUTAMENTE da CAMBIARE!!!!
      const rootUrl = process.env.TZB_API_PUB.slice(0, -3)
      window.location.href = `${rootUrl}/auth/google`
    },

    async sendRequest() {
      const isValid = this.validate()
      console.log(isValid)
      if (isValid) {
        // const contacts = await searchContactByCF(this.userRequest)
        const filter = {
          where: {
            codiceFiscale: this.userRequest.codiceFiscale.toUpperCase(),
          },
        }
        const contacts = await this.$api.get('TzbContacts', filter)
        if (contacts.length) {
          const { id } = contacts[0]
          this.userRequest.contactId = id
          //          this.userRequest._contact = { id, nickname }
        }
        // console.log(contact) brgpgr74m19c722k
        this.userRequest.schoolId = this.userRequest.school.id
        await this.$api.put('TzbWaitingUsersLists', this.userRequest)
        // setWaitingList(this.userRequest)
        this.requestSent = true
      } else {
        this.validateInputs = true
      }
    },
    validate() {
      return (
        this.userRequest.lastName.length >= 3 &&
        this.userRequest.firstName.length >= 3 &&
        this.userRequest.codiceFiscale.length === 16 &&
        this.userRequest.school.id.length &&
        cf.check(this.userRequest.codiceFiscale)
      )
    },
    checkCF(codiceFiscale) {
      return cf.check(codiceFiscale)
    },
  },
}
</script>

<style scoped>
.button {
  margin-top: 20px;
}

.transparent {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue